<template>

    <a-yoga-layout
        width-auto="1" height-auto="1"
        padding="0"
        flex-direction="column"

        geometry="primitive: plane;" material="visible: false"
    >

        <a-video
            yoga-layout-item="margin: 0.05; marginEdge: bottom"
            :src="'#video-'+block.field_values.video.id"
            :width="videoWidth" :height="videoHeight"
        ></a-video>
      
      <a-html autoEnable="false">
        <div class="vr">
          <div v-html="block.field_values.html"></div>
        </div>
      </a-html>

    </a-yoga-layout>

</template>

<script>
export default {
    name: "VideoBlock",
    props: ['block'],
    computed: {
        videoWidth() {
            return 2;
        },
        videoHeight() {
            return this.block.field_values.video.height / this.block.field_values.video.width * this.videoWidth;
        }
    }
}
</script>

<style scoped>

</style>